/**
 * The below file contains the Livestock Types state objects
 * @author: shivam.sharma2@velsof.com
 * @date : 12-01-2023
 */

import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  SET_ALL_LIVESTOCK_TYPES,
} from "redux/constants/LivestockTypes";

//Initial state
const initState = {
  // Keys for dropdown 
  livestockList: [],
  isLivestockDataFetched: false,
  // Keys for dropdown 
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const livestockTypes = (state = initState, action) => {
  switch (action.type) {
    //Cases for Livestock Types dropdown
    case SET_ALL_LIVESTOCK_TYPES:
      return {
        ...state,
        livestockList: action.payload,
        isLivestockDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };
    //Cases for Livestock Types dropdown

    default:
      return state;
  }
};

export default livestockTypes;
